import type { RadioChangeEvent } from 'antd';
import { Radio } from 'antd';
import React, { FC } from 'react';
import styles from './Filters.module.less';

type Props = {
  value?: string;
  onChange?: (value?: string) => void;
  onCancel?: () => void;
};

export const AdStatusFilter: FC<Props> = (props) => {
  const onChange = (e: RadioChangeEvent) => {
    props.onChange?.(e.target.value);
  };
  return (
    <Radio.Group onChange={onChange} value={props.value} className={styles.adStatusFilter}>
      <Radio value={'All'} id={'search-bar-radio-all'}>
        All
      </Radio>
      <Radio value={'Active'} id={'search-bar-radio-active'}>
        Active
      </Radio>
      <Radio value={'Expired'} id={'search-bar-radio-expired'}>
        Expired
      </Radio>
    </Radio.Group>
  );
};
